export default {
    methods: {
        getRgba(color, alphaValue) {
            // for shorthand values #123, if applicable
            if (color.length === 4) {
                color = `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
            }

            let redValue = parseInt(color.slice(1, 3), 16);
            let greenValue = parseInt(color.slice(3, 5), 16);
            let blueValue = parseInt(color.slice(5, 7), 16);

            return `rgba(${redValue}, ${greenValue}, ${blueValue}, ${alphaValue})`;
        }
    }
}
